<template>
  <!-- I haven't made any change to this template. This is only copy and paste from doc site. -->
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-right">
            <importxlsx @onChange="importCsv"></importxlsx>
            <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
            <v-btn outline color="primary" @click="showAdvanceSearch"> Advance search </v-btn>
          </div>
        </v-flex>
        <v-flex xs6>
          <v-pagination
            @input="changepage"
            v-model="page"
            :length="pagelength"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
        <v-flex xs6>
          <!-- <div class="form-control">
            <div style="position: relative">
              <input class="mb-0" placeholder="Search" v-model="search.title" type="text" />
              <v-btn
                :loading="loading"
                style="position: absolute; right: 5px; top: 5px"
                class="ma-0"
                icon
                ><v-icon color="primary">search</v-icon></v-btn
              >
            </div>
          </div> -->
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.material_number }}</td>
            <td>{{ props.item.producttype }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.productname_en }}</td>
            <td>{{ props.item.model }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.size }}</td>
            <td>{{ props.item.headtype }}</td>
            <td>{{ props.item.colour_tone }}</td>
            <td>{{ props.item.colour }}</td>
            <td>{{ props.item.price | numberFormat }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detaildialog" width="660px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="detaildialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div><ProductDetail v-if="detaildialog" :detaildata="detaildata"></ProductDetail></div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advancesearch" persistent width="500px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn @click="advancesearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="form-control">
          <label>Material Number </label>
          <input v-model="filter.material_number" type="text" />
        </div>
        <!-- <div class="form-control mb-2">
          <label>Product Name</label>
          <v-autocomplete
            v-model="filter.product"
            :items="products"
            cache-items
            flat
            hide-no-data
            hide-details
            label="Product"
            solo
          ></v-autocomplete>
        </div> -->
        <div class="form-control mb-2">
          <label>Model</label>
          <multiselect
            v-model="filter.model"
            :options="models"
            selectLabel
            selectedLabel
            :searchable="true"
            deselect-label
          ></multiselect>
        </div>
        <div class="form-control mb-2">
          <label>Size</label>
          <multiselect
            v-model="filter.size"
            :options="sizes"
            selectLabel
            selectedLabel
            :searchable="true"
            deselect-label
          ></multiselect>
        </div>
        <div class="form-control mb-2">
          <label>Headtype</label>
          <multiselect
            v-model="filter.headType"
            :options="headTypes"
            selectLabel
            selectedLabel
            :searchable="true"
            deselect-label
          ></multiselect>
        </div>
        <div class="form-control mb-2">
          <label>Color</label>
          <multiselect
            v-model="filter.colour_tone"
            :options="colors"
            selectLabel
            selectedLabel
            :searchable="true"
            deselect-label
          ></multiselect>
        </div>

        <div>
          <v-btn @click="onSearch" block color="primary" depressed>ค้นหา</v-btn>
          <v-btn @click="clearSearch" block color="grey" outline>Clear search</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import ProductDetail from './ProductDetail.vue'
import Multiselect from 'vue-multiselect'
import api from '@/api'
export default {
  components: {
    exportxlsx,
    importxlsx,
    ToggleButton,
    ProductDetail,
    Multiselect
  },
  data: () => ({
    items: [],
    loading: false,
    limit: 10,
    page: 1,
    pagetmp: 1,
    pagetotal: 0,
    offset: 0,
    detaildialog: false,
    detaildata: '',
    filter: {
      start_date: '',
      end_date: '',
      material_number: '',
      product: '',
      model: '',
      category: '',
      size: '',
      headtype: '',
      colour_tone: ''
    },
    headers: [
      {
        text: 'Material Number (Old Code)',
        sortable: false,
        value: 'material_number'
      },
      {
        text: 'Product Type',
        sortable: false,
        value: 'product_type'
      },
      {
        text: 'Status',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Product Name',
        sortable: false,
        value: 'product_name'
      },
      {
        text: 'Model',
        sortable: false,
        value: 'model'
      },
      {
        text: 'Category',
        sortable: false,
        value: 'category'
      },
      {
        text: 'Size',
        sortable: false,
        value: 'size'
      },
      {
        text: 'Headtype',
        sortable: false,
        value: 'headtype'
      },
      {
        text: 'Tone',
        value: 'toner'
      },
      {
        text: 'Color',
        value: 'color'
      },
      {
        text: 'Price',
        value: 'price'
      }
    ],
    advancesearch: false,
    products: [
      'PEN',
      'PENCIL',
      'INK BOTTLE',
      'BALL PEN REFILL',
      'MARKER REFILL',
      'ROLLERBALL REFILL',
      'INK CARTRIDGE',
      'NOTBOOK',
      'BOOKLET',
      'CASE',
      'COLOUR BOWL',
      'CONVERTER',
      'WATER COLOUR'
    ],
    models: [
      'FOUNTAIN_PEN_2000',
      'FOUNTAIN_PEN_ABC',
      'FOUNTAIN_PEN_ACCENT',
      'FOUNTAIN_PEN_AION',
      'FOUNTAIN_PEN_AL-STAR',
      'FOUNTAIN_PEN_CP_1',
      'FOUNTAIN_PEN_DIALOG',
      'FOUNTAIN_PEN_IMPORIUM',
      'FOUNTAIN_PEN_JOY',
      'FOUNTAIN_PEN_LOGO',
      'FOUNTAIN_PEN_LX',
      'FOUNTAIN_PEN_SAFARI',
      'FOUNTAIN_PEN_SCALA',
      'FOUNTAIN_PEN_STUDIO',
      'FOUNTAIN_PEN_ST',
      'FOUNTAIN_PEN_VISTA',
      'FOUNTAIN_PEN_Boxset',
      'BALL_PEN_2000',
      'BALL_PEN_ACCENT',
      'BALL_PEN_AION',
      'BALL_PEN_AL-STAR',
      'BALL_PEN_CP_1',
      'BALL_PEN_DIALOG',
      'BALL_PEN_IMPORIUM',
      'BALL_PEN_LOGO',
      'BALL_PEN_LOGO_M',
      'BALL_PEN_LOGO_M+',
      'BALL_PEN_LX',
      'BALL_PEN_PICO',
      'BALL_PEN_SAFARI',
      'BALL_PEN_SCALA',
      'BALL_PEN_SCRIBBLES',
      'BALL_PEN_STUDIO',
      'BALL_PEN_VISTA',
      'ROLLER_BALL_PEN_2000',
      'ROLLER_BALL_PEN_ACCENT',
      'ROLLER_BALL_PEN_AION',
      'ROLLER_BALL_PEN_AL-STAR',
      'ROLLER_BALL_PEN_DIALOG',
      'ROLLER_BALL_PEN_IMPORIUM',
      'ROLLER_BALL_PEN_LOGO',
      'ROLLER_BALL_PEN_LX',
      'ROLLER_BALL_PEN_SAFARI',
      'ROLLER_BALL_PEN_SCALA',
      'ROLLER_BALL_PEN_STUDIO',
      'ROLLER_BALL_PEN_SWIFT',
      'ROLLER_BALL_PEN_TIPO_Al',
      'ROLLER_BALL_PEN_TIPO_K',
      'ROLLER_BALL_PEN_VISTA',
      'PENCIL_2000',
      'PENCIL_ABC',
      'PENCIL_ACCENT',
      'PENCIL_AL-STAR',
      'PENCIL_CP_1',
      'PENCIL_IMPORIUM',
      'PENCIL_LOGO',
      'PENCIL_SAFARI',
      'PENCIL_SCALA',
      'PENCIL_SCRIBBLES',
      'PENCIL_ST',
      'PENCIL_VISTA',
      'MULTISYSTEM_PEN_2000',
      'DIGITAL_PEN_AL-STAR_EMR_Digital',
      'MULTISYSTEM_PEN_CP_1_tri_pen',
      'MULTISYSTEM_PEN_CP_1_twin_pen',
      'MULTISYSTEM_PEN_LOGO_3_Colors',
      'MULTISYSTEM_PEN_LOGO_twin_pen',
      'MULTISYSTEM_PEN_ST_tri_pen',
      'MULTISYSTEM_PEN_st_tri_pen_(2_+_1)',
      'MULTISYSTEM_PEN_st_twin_pen',
      'INK_BOTTLE_T51',
      'INK_BOTTLE_T52',
      'INK_BOTTLE_T53',
      'BALL_PEN_REFILL_M16',
      'BALL_PEN_REFILL_M21',
      'BALL_PEN_REFILL_M22',
      'MARKER_REFILL_M55',
      'ROLLERBALL_REFILL_M63',
      'ROLLERBALL_REFILL_M66',
      'ROLLERBALL_REFILL_T11',
      'INK_CARTRIDGE_T10',
      'NOTBOOK_softcover_A5',
      'NOTBOOK_softcover_A6',
      'NOTBOOK_hardcover_A5',
      'NOTBOOK_hardcover_A6',
      'BOOKLET_Softcover_A5',
      'BOOKLET_Softcover_A6',
      'CASE_ACCESSORIES',
      'Colour_Bowl_ACCESSORIES',
      'CONVERTER_Z_27',
      'CONVERTER_Z_28',
      'Weter_Colour_ACCESSORIES',
      'BALL_PEN_SAFARI SAVANNAH',
      'FOUNTAIN_PEN_Boxset_SAFARI SAVANNAH',
      'FOUNTAIN_PEN_AION_DARKGREEN',
      'BALL_PEN_AION DARKGREEN',
      'ROLLER_BALL_PEN_AION DARKGREEN',
      'FOUNTAIN_PEN_Boxset_AL-STAR COSMIC & AZURE',
      'BALL_PEN_AL-STAR COSMIC & AZURE',
      'ROLLER BALL_PEN_AL-STAR COSMIC & AZURE',
      'PEN POUCH LAMY safari',
      'Savannah Tin Box',
      'PEN POUCH COSMIC & AZURE',
      'METAL BOX COSMIC & AZURE',
      'SET LAMY 2000 Brown Limited Edition 2021',
      'BALL PEN AL-STAR GOLD BLACK CLIP',
      'ROLLER BALL PEN AL-STAR GOLD BLACK CLIP'
    ],
    headTypes: [
      'FOUNTAIN PEN',
      'BALL PEN',
      'ROLLER BALL PEN',
      'PENCIL',
      'MULTISYSTEM PEN',
      'DIGITAL PEN',
      'INK BOTTLE',
      'BALL PEN REFILL',
      'MARKER REFILL',
      'ROLLERBALL REFILL',
      'INK CARTRIDGE',
      'Notbook',
      'Booklet',
      'OTHERS',
      'Colour Bowl',
      'CONVERTER',
      'Water Colour',
      'Boxset'
    ],
    colors: [
      'ดำ',
      'สแตนเลส',
      'น้ำเงิน',
      'แดง',
      'ดำ ไดมอนด์โคท',
      'ดำ ไบรอาร์',
      'บรอนเงิน',
      'บรอนซิลเวอร์',
      'น้ำเงินดาร์คบูล',
      'เทา แกรไฟต์',
      'เขียวฟ้าน้ำทะเล',
      'ม่วง',
      'เขียวอมฟ้า',
      'ชมพูไวเบริน พิ้งค์',
      'ฟ้าน้ำทะเล',
      'ฟ้า ทัวร์มาลีน',
      'บรอนซทอง',
      'เงินแพลทินัม',
      'เทาเงินเพิลเลเดียม',
      'ดำด้าน',
      'ดำเปียโนแบล็ค',
      'ขาวเปียโนไวท์',
      'เทาไทเทเนียม',
      'ดำอะลูมิเนียมแบล็ค',
      'ขาว',
      'ไวท์',
      'แดง',
      'อะลูมิเนียม',
      'เทารูทีเนียม',
      'ทอง',
      'โรสโกลด์',
      'น้ำตาลมารอน',
      'ชมพู',
      'เทาดำอัมบระ',
      'เหลือง',
      'ดำเงา',
      'เขียว',
      'ดำออแบล็ค',
      'ฟ้าพาสเทล',
      'ชมพูโรส',
      'ม่วงดาร์คไวเออะเลิท',
      'น้ำเงินอิมเพียเรียลบลู',
      'เทาเพิลเลเดียม',
      'เขียวมะกอก',
      'ส้มอิฐเทราคอททา',
      'เขียวอ่อนอความารีน',
      'เขียวแกมฟ้า',
      'ใส',
      'โกลด์',
      'ทอง-ชมพู-เทาเข้ม-เทาเงิน',
      'น้ำตาลแบล็ควูด',
      'สแตนเลส สตีล',
      'ลายไม้เทกซัล',
      'ดำไดมอนด์โคท',
      'ดำไบรอาร์',
      'บรอนโอลิฟว์ซิลเวอร์',
      'เทาแกรไฟต์',
      'ม่วงแบล็คเพอเพิล',
      'ฟ้าทัวร์มารีน',
      'เทาไททาเนียม',
      'ส้ม',
      'ม่วงดำแบล็คเบอร์รี่',
      'ฟ้า',
      'น้ำเงินไนท์บลู',
      'เขียวอ่อนอะความารีน',
      'เงิน',
      'เงินแมท',
      'เขียวนีออน',
      'เขียวอ่อนนีออน',
      'เทาดำเพิลเลเดียม',
      'ฟ้าเกลเซีย',
      'เทาแอนธระไซท์',
      'ไข่มุกเพิล',
      'กาแฟ',
      'เขียวมรกต',
      'น้ำเงินเขียวเพทโทรล',
      'ส้มคอปเปอร์',
      'น้ำเงินเข้ม',
      'เหลืองแมงโก',
      'ไวน์แดง',
      'ม่วงเบอร์รี่',
      'ฟ้าคราม',
      'เขียวเข้ม',
      'น้ำตาล',
      'เทา',
      'ส้ม',
      'ม่วงเข้ม',
      'ฟ้าเข้ม',
      'ชมพู',
      'แดงเข้ม',
      'ชมพูเฟลช',
      'แดงมาเจนต้า',
      'แดงเวอมิลเยิน',
      'เหลืองอ่อน',
      'เหลืองเข้ม',
      'เหลืองอมน้ำตาล',
      'น้ำตาลอมเหลือง',
      'ม่วง',
      'ฟ้าอมเขียว',
      'น้ำเงินอมเขียว',
      'เขียวอ่อน',
      'เหลืองอมเขียว',
      'น้ำตาลเข้ม',
      'เทาดำ',
      'ส้มอิฐ',
      'ชมพูอมเทา',
      'ฟ้าธารน้ำแข็ง',
      'เขียวดำ'
    ],
    sizes: [
      'EF',
      'F',
      'OM',
      'B',
      'OB',
      'BB',
      'OBB',
      'M',
      'A',
      'LH',
      '1.1',
      '1.5',
      '1.9',
      'BP',
      'RB',
      '0.5',
      '0.7',
      '1.4',
      '3.15',
      '4-colours',
      '0.35',
      '3-colours',
      '2-colours',
      '30ml',
      '50ml',
      'A5',
      'A6'
    ]
  }),

  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.limit = this.pagetotal
        var data = await this.getProducts()

        resolve(
          data.map((el) => {
            return {
              'Material Number (Old Code)': el.material_number,
              'Product Type': el.product_type,
              Status: el.status,
              'Product Name': el.productname_en,
              Model: el.model,
              Category: el.category,
              Size: el.size,
              Headtype: el.headtype,
              Tone: el.colour_tone,
              Color: el.colour,
              Price: el.price
            }
          })
        )

        this.limit = 10
        this.clearSearch()
      })
    },
    // exportXlsx() {
    //   this.limit = this.pagetotal;
    //   this.getProducts();
    //   var json = this.items.map((el) => {
    //     return {
    //       'Material Number (Old Code)': el.material_number,
    //       'Product Type': el.product_type,
    //       Status: el.status,
    //       'Product Name': el.productname_en,
    //       Model: el.model,
    //       Category: el.category,
    //       Size: el.size,
    //       Headtype: el.headtype,
    //       Tone: el.colour_tone,
    //       Color: el.colour,
    //       Price: el.price,
    //     }
    //   })
    //   return json
    // },
    // },
    showAdvanceSearch() {
      this.advancesearch = true
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getProducts()
      }
    },
    onSearch() {
      this.advancesearch = false
      this.getProducts()
    },
    clearSearch() {
      ;(this.filter = {
        start_date: '',
        end_date: '',
        material_number: '',
        product: '',
        model: '',
        category: '',
        size: '',
        headtype: '',
        colour_tone: ''
      }),
        (this.advancesearch = false)
      this.getProducts()
    },
    getProducts() {
      return new Promise((resolve) => {
        var vm = this
        vm.offset = vm.page * 10 - 10
        if (vm.page != 1) {
          vm.offset + 1
        }
        var data = {
          pageid: vm.selectedBot.pageid, // required
          start_date: vm.filter.start_date, // YYYY-MM-DD
          end_date: vm.filter.end_date, // YYYY-MM-DD
          // material_number: vm.filter.material_number,
          // producttype: vm.filter.producttype,
          // model: vm.filter.model,
          // category: vm.filter.category,
          // size: vm.filter.size,
          // headtype: vm.filter.headtype,
          // colour_tone: vm.filter.colour_tone,
          limit: vm.limit,
          offset: vm.offset
        }
        for (const [key, value] of Object.entries(this.filter)) {
          if (value) {
            Object.assign(data, { [key]: value })
          }
        }
        this.loading = true
        api.getLamyProductMaster(data, (err, response) => {
          if (response.responsecode == 200) {
            this.pagetotal = parseInt(response.total)
            this.loading = false
            this.items = response.data
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    showDetail(item) {
      this.detaildata = item
      this.detaildialog = true
    },
    onChangeBranchStatus(index) {
      this.items[index].status = !this.items[index].status
    },
    importCsv(file) {
      var data = {
        files: file[0],
        pageid: this.selectedBot.pageid
      }
      api.postLamyImportProductMaster(data, async (err, response) => {
        if (response.responsecode == 200) {
          await this.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          this.getProducts()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ProductAndBranch/Product.vue